import { render, staticRenderFns } from "./BonusIncome.vue?vue&type=template&id=0c675ef2"
import script from "./BonusIncome.vue?vue&type=script&lang=js"
export * from "./BonusIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports